export default "__VITE_ASSET__ssVSzKX6__"